import React, { useContext } from "react";

import {
  Flex,
  Container,
  Text,
  Box,
  TransparentButton,
  Divider,
} from "flicket-ui";

import { useRouter } from "next/router";
import useSWR from "swr";
import {
  Layout,
  Footer,
  BottomBar,
  Menu,
  Seo,
  Icon,
  ContentContainer,
  SlateRenderer,
} from "~components";
import { BaseContext } from "~context";
import { showToast, getError, sdk } from "~lib";

const getMemberships = async (_: string, orgId: string, membershipId) =>
  sdk({ orgId }).membership({ id: membershipId });

const swrConfig = {
  shouldRetryOnError: false,
};

const TermsAndConditions = () => {
  const router = useRouter();
  const { organization } = useContext(BaseContext);
  const { data, error } = useSWR(
    organization?.id && router?.query?.membershipId
      ? ["memberships", organization?.id, router?.query?.membershipId]
      : null,
    getMemberships,
    swrConfig
  );

  if (error) {
    showToast(getError(error, "graphQL"), "error");
  }

  return (
    <>
      <Seo
        title={`${
          data?.membership?.name && data?.membership?.name + ": "
        }Terms and Conditions`}
        description={`${
          data?.membership?.name && data?.membership?.name + ": "
        }Terms and Conditions`}
      />
      <Menu />
      <Flex flexDirection="column" flex={1}>
        <Box d={{ _: "block", md: "none" }}>
          <Flex px={2} py={3}>
            <TransparentButton
              mr={2}
              to={`/memberships/${data?.membership?.id}`}
            >
              <Icon icon="chevron-left" fontSize={6} color="N800" />
            </TransparentButton>
            <Text
              lineHeight="normal"
              fontSize={6}
              fontWeight="extraBold"
              color="N800"
            >
              {data?.membership?.name && data?.membership?.name + ": "}Terms and
              Conditions
            </Text>
          </Flex>
          <Divider />
        </Box>
        <Flex
          flexDirection="column"
          flex={1}
          maxH={{ _: "calc(100vh - 73px)", md: "unset" }}
          overflowY={{ _: "auto", md: "visible" }}
        >
          <Layout layoutType="overlay">
            <ContentContainer
              variant="content"
              image={data?.membership?.backgroundImage}
            >
              <Flex flexDir="column" pb={{ _: 2, md: 0 }} flex="1">
                <Box
                  d={{ _: "none", md: "block" }}
                  width="100%"
                  maxWidth="1248px"
                  pl={4}
                  mx={"auto" as any}
                >
                  <TransparentButton
                    to={`/memberships/${data?.membership?.id}`}
                  >
                    <Flex alignItems="center" opacity="inherit">
                      <Icon icon="chevron-left" fontSize={5} color="white" />
                      <Text
                        color="white"
                        fontWeight="extraBold"
                        fontSize={3}
                        lineHeight="medium"
                        ml="3/4"
                      >
                        Back to Membership
                      </Text>
                    </Flex>
                  </TransparentButton>
                  <Text
                    color="white"
                    fontWeight="heavy"
                    fontSize={9}
                    lineHeight={"56px" as any}
                    my={1}
                  >
                    {data?.membership?.name && data?.membership?.name + ": "}
                    Terms and Conditions
                  </Text>
                </Box>
                <Container
                  mb={{ _: 0, md: 10 }}
                  innerProps={{
                    minHeight: { _: 0, md: "320px" },
                  }}
                >
                  {data?.membership?.termsAndConditions ? (
                    <SlateRenderer
                      value={data?.membership?.termsAndConditions}
                    />
                  ) : (
                    <Text mb={{ _: 1, md: 2 }}>
                      Terms and Conditions coming soon!
                    </Text>
                  )}
                </Container>
              </Flex>
              <Footer />
            </ContentContainer>
          </Layout>
        </Flex>
      </Flex>
      <BottomBar />
    </>
  );
};

export default TermsAndConditions;
